import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import PackagesApi from '../../../../services/api/PackagesApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import createIcon from '../../../../static/img/createIcon.svg';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

export default function PackageEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState({
    name: '',
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let res = null;
    if (id) {
      res = await PackagesApi.update(id, values);
    } else {
      res = await PackagesApi.create(values);
    }
    if (res.status === StatusCodes.OK) {
      history.push('/packages');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const res = await PackagesApi.get(id);
    const newItemData = { ...res.data, dataArrived: true };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <>
      <WhitePad>
        <TitleComponent
          title={`${id ? 'Edit ' : 'Create '} Package`}
          titleRight="Create"
          onLeftHandler={() => {
            history.goBack();
          }}
          iconRight={createIcon}
        />
        {id && itemData.dataArrived === false ? null : (
          <Formik
            initialValues={{
              name: itemData.name,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              return saveItem(values, setSubmitting);
            }}
          >
            {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <FormWrapper>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <FormRow>
                    <TextInputComponent
                      name="name"
                      label="Name"
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                    />
                  </FormRow>
                  <PrimaryButton variant="primary" isSubmitting={isSubmitting} type="submit" title="Save" />
                </form>
              </FormWrapper>
            )}
          </Formik>
        )}
      </WhitePad>
    </>
  );
}
